import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = {
  class: "tab-list",
  role: "tablist"
}
const _hoisted_3 = { class: "tab-panels-container" }
const _hoisted_4 = ["id", "inert", "aria-hidden", "aria-labelledby"]

import type { Component, CSSProperties } from 'vue'

import { isRTL } from '@nextcloud/l10n'
import { computed, ref } from 'vue'
import NcButton from '@nextcloud/vue/components/NcButton'
import TransitionExpand from './TransitionExpand.vue'

type TabDefinition = {
	id: string
	label: string
	icon: Component
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaSettingsTabs',
  props: {
    tabs: {},
    active: {}
  },
  emits: ["update:active"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

/** Whether the tab panel is open */
const isOpen = ref(!!props.active)

const isRTLDirection = isRTL()

// A11y ReferenceIDs
const randomId = Math.random().toString(36).substring(7)
const getRefId = (scope: 'tab' | 'panel', key: string) => `tab-${randomId}-${scope}-${key}`

/** Index of the active tab for the transition effect */
const activeIndex = computed(() => props.tabs.findIndex((tab) => tab.id === props.active))
/** Inline styles to shift tabs */
const tabStyles = computed<CSSProperties | undefined>(() => {
	return activeIndex.value !== -1
		? { transform: `translateX(${(isRTLDirection ? 1 : -1) * activeIndex.value * 100}%)` }
		: undefined
})

/**
 * Whether the tab is active
 *
 * @param tabId - Tab ID
 */
function isActive(tabId: string) {
	return tabId === props.active
}

/**
 * Whether the tab is selected on UI
 *
 * @param tabId - Tab ID
 */
function isSelected(tabId: string) {
	return isOpen.value && isActive(tabId)
}

/**
 * Toggle the tab:
 * - Toggle the tab on the current tab click
 * - Switch and open tab on a new tab click
 *
 * @param tabId - New selected tabId
 */
function handleTabClick(tabId: string) {
	if (!isActive(tabId)) {
		emit('update:active', tabId)
		isOpen.value = true
	}
}

/**
 * Handle the tab panel closing transition finish
 */
function handleTabsAfterClosed() {
	// Emit tab change to none only when the tab panel is fully closed
	// Otherwise visually open tab disappears with transition during closing
	emit('update:active', undefined)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
        return (_openBlock(), _createBlock(_unref(NcButton), {
          id: getRefId('tab', tab.id),
          key: tab.id,
          role: "tab",
          variant: isSelected(tab.id) ? 'secondary' : 'tertiary',
          "aria-selected": isSelected(tab.id) ? 'true' : 'false',
          "aria-controls": getRefId('panel', tab.id),
          onClick: _withModifiers(($event: any) => (handleTabClick(tab.id)), ["stop"])
        }, {
          icon: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), { size: 20 }))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(tab.label), 1)
          ]),
          _: 2
        }, 1032, ["id", "variant", "aria-selected", "aria-controls", "onClick"]))
      }), 128))
    ]),
    _createVNode(TransitionExpand, {
      show: isOpen.value,
      direction: "vertical",
      onAfterLeave: handleTabsAfterClosed
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              id: getRefId('panel', tab.id),
              key: tab.id,
              class: "tab-panel",
              role: "tabpanel",
              inert: !isActive(tab.id),
              "aria-hidden": !isActive(tab.id),
              "aria-labelledby": getRefId('tab', tab.id),
              style: _normalizeStyle(tabStyles.value)
            }, [
              _renderSlot(_ctx.$slots, `tab-panel:${tab.id}`)
            ], 12, _hoisted_4))
          }), 128))
        ])
      ]),
      _: 3
    }, 8, ["show"])
  ]))
}
}

})